import api from "./apiClient";

export async function ResetPassword(reset_token, newPass) {
	const response = await api.post("/forgot-password/reset", {
		reset_password_token: reset_token,
		password_type: "reset",
		email: "",
		newpassword: newPass
	}, {
		skipAuth: true  // Password reset doesn't require authentication
	});
	return response;
}

export async function ChangePassword(email, newPass, oldPass) {
	const response = await api.post("/forgot-password/reset", {
		password_type: "change",
		email: email,
		newpassword: newPass,
		oldpassword: oldPass,
	}, {
		skipAuth: true  // Password change endpoint doesn't require authentication
	});
	return response;
}